import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { Grid } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import useStyles from './useStyles'

export default function StepperSeeMoreSuborganization ({
  setstateSeeMore,
  item,
  types
}) {
  const classes = useStyles()

  const getTypeName = (code) => {
    const result = types.filter(
      (element) => element.suborganizationTypeCode === code
    )
    if (result && result.length > 0) {
      return result[0].suborganizationTypeName
    } else {
      return null
    }
  }

  const Suborganization = ({ item }) => {
    return (
      <>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Nombre:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.suborganizationName || '- -'}{' '}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Nombre legal:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.suborganizationLegalName || '- -'}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>CUIT:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.cuit || '- -'}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>
              Tipo de suborganización:
            </Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {getTypeName(item.suborganizationTypeCode) || '- -'}
            </Typography>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            padding: '8px 0px 8px 0px',
            justifyContent: 'space-between',
            boxShadow: '0px 1px 1px #EAEAEA',
            color: '#8C8C8C'
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del estudio
          </Typography>
          <CloseIcon
            style={{
              cursor: 'pointer',
              paddingRight: 10,
              fontSize: '1.5rem'
            }}
            onClick={() => {
              setstateSeeMore(false)
            }}
          />
        </div>
        <div className={classes.mainBox}>
          <Suborganization item={item} />
        </div>

        <ButtonClose setstateSeeMore={setstateSeeMore} />
      </Box>
    </>
  )
}

function ButtonClose ({ setstateSeeMore }) {
  const classes = useStyles()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          '&:hover': {
            bgcolor: '#1BF57F'
          }
        }}
      >
        <Typography
          onClick={() => {
            setstateSeeMore(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
